(function () {
  'use strict';

  function cleanText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function keyText(value) {
    return cleanText(value)
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function colorIdentity(value) {
    var key = keyText(value);

    if (key === 'gray') key = 'grey';
    if (key === 'offwhite' || key === 'off white') key = 'off white';
    if (key === 'multi color' || key === 'multi colour' || key === 'multicolour') key = 'multicolor';

    var label = cleanText(value);
    if (key === 'grey') label = 'Grey';
    if (key === 'off white') label = 'Off White';
    if (key === 'multicolor') label = 'Multicolor';

    return { key: key, label: label };
  }

  function itemLabel(li) {
    var text = li.querySelector('.tag__text');
    if (text) return cleanText(text.textContent);
    var input = li.querySelector('input.tag__input');
    return input ? cleanText(input.value) : '';
  }

  function prepareGroup(group) {
    var header = group.querySelector('.tag-list__header');
    if (!header) return;

    var groupName = keyText(header.textContent);
    var outer = group.parentElement;
    var items = Array.prototype.slice.call(group.querySelectorAll('li.tag'));

    // Catalogue hygiene: hide the known orientation words that were incorrectly
    // entered as Fabric/Occasion values. This is presentation-only; source data
    // should still be cleaned in Shopify Admin/Search & Discovery.
    if (groupName.indexOf('fabric') !== -1 || groupName.indexOf('occasion') !== -1) {
      items.forEach(function (li) {
        var valueKey = keyText(itemLabel(li));
        if (valueKey === 'vertical' || valueKey === 'portrait') {
          li.hidden = true;
          li.classList.add('cc-filter-invalid-term');
        }
      });
    }

    // Technique/pattern labels and catch-all "Other" are not fabric values.
    // Never hide an actively selected checkbox; clearing a filter must remain possible.
    items.forEach(function (li) {
      var input = li.querySelector('input.tag__input');
      if (!input || input.checked) return;
      var valueKey = keyText(itemLabel(li));
      var isFabric = groupName.indexOf('fabric') !== -1;
      var invalidFabric = isFabric && (
        valueKey === 'bandhani' || valueKey === 'jari stripe' ||
        valueKey === 'zari stripe' || valueKey === 'printed' ||
        valueKey === 'embroidery'
      );
      var lowValue = valueKey === 'other' || valueKey === 'others' || valueKey === 'miscellaneous';
      if (invalidFabric || lowValue) {
        li.hidden = true;
        li.classList.add('cc-filter-invalid-term');
      }
    });
    if ((groupName === 'other' || groupName === 'others' || groupName === 'miscellaneous') && outer && !group.querySelector('input.tag__input:checked')) {
      outer.hidden = true;
      outer.classList.add('cc-low-value-filter');
    }

    // Merge duplicate colour spellings/casing in the visible UI. Alias checkbox
    // inputs are moved into the first visible row so a single click submits all
    // equivalent catalogue values instead of silently losing inventory.
    if (groupName.indexOf('color') !== -1 || groupName.indexOf('colour') !== -1) {
      var seen = Object.create(null);

      items.forEach(function (li) {
        if (li.hidden || li.classList.contains('hide')) return;
        var input = li.querySelector('input.tag__input');
        if (!input) return;

        var identity = colorIdentity(itemLabel(li) || input.value);
        if (!identity.key) return;

        var text = li.querySelector('.tag__text');
        if (text) text.textContent = identity.label;
        input.dataset.ccColorKey = identity.key;

        if (!seen[identity.key]) {
          seen[identity.key] = li;
          li.dataset.ccColorPrimary = identity.key;
          return;
        }

        var primary = seen[identity.key];
        var primaryInput = primary.querySelector('input.tag__input:not(.cc-filter-alias-input)') || primary.querySelector('input.tag__input');

        if (input.checked && primaryInput) primaryInput.checked = true;
        input.hidden = true;
        input.classList.add('cc-filter-alias-input');
        input.dataset.ccColorKey = identity.key;
        primary.appendChild(input);
        li.hidden = true;
        li.classList.add('cc-filter-duplicate');
      });
    }

    // Hide filters that provide no meaningful choice, unless a value is already
    // active (active filters must stay reachable so shoppers can remove them).
    var visibleChoices = Array.prototype.slice.call(group.querySelectorAll('li.tag')).filter(function (li) {
      return !li.hidden && !li.classList.contains('hide') && li.querySelector('input.tag__input');
    }).length;
    var hasActive = !!group.querySelector('input.tag__input:checked');
    var isPrice = groupName.indexOf('price') !== -1;

    if (outer && !isPrice) {
      outer.hidden = visibleChoices < 2 && !hasActive;
      outer.classList.toggle('cc-low-value-filter', visibleChoices < 2 && !hasActive);
    }
  }

  function prepareFilters() {
    document.querySelectorAll('.collection-sidebar__group').forEach(prepareGroup);
  }

  // Capture phase runs before the theme's normal filter change handler, so
  // merged colour aliases are checked/unchecked before the form is serialized.
  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest ? event.target.closest('input.tag__input[data-cc-color-key]') : null;
    if (!input || input.classList.contains('cc-filter-alias-input')) return;

    var group = input.closest('.collection-sidebar__group');
    if (!group) return;
    var key = input.dataset.ccColorKey;

    group.querySelectorAll('input.tag__input[data-cc-color-key]').forEach(function (other) {
      if (other.dataset.ccColorKey === key) other.checked = input.checked;
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareFilters, { once: true });
  } else {
    prepareFilters();
  }

  document.addEventListener('collection:reloaded', function () {
    window.requestAnimationFrame(prepareFilters);
  });
})();
